import React from "react";
import { MuiTypography, MuiListItem, MuiListItemText } from '../../../ui/MaterialUIComponents';
import { gradePickerUtil } from "../../gradePicker";
import { toast } from "react-toastify";
import * as Constants from '../../../../constants';
import * as RulesDisplay from './RulesDisplayClass';
import './Rules.css';

const getTableCellForSubjects = (cellData, radioOption) => {
    switch (radioOption) {
        case Constants.RULES_SHOW_RADIO_PERIOD:
            return new RulesDisplay.SubjectsRulesDisplayPeriod(cellData);
        case Constants.RULES_SHOW_RADIO_PERIOD_PREFS:
            return new RulesDisplay.SubjectsRulesDisplayPeriodPref(cellData);
        case Constants.RULES_SHOW_RADIO_ROOMS:
            return new RulesDisplay.SubjectsRulesDisplayRooms(cellData);
        case Constants.RULES_SHOW_RADIO_TEACHERS:
            return new RulesDisplay.SubjectsRulesDisplayTeachers(cellData);
        case Constants.RULES_SHOW_RADIO_ASSIGNED_TEACHERS:
            return new RulesDisplay.SubjectsAssignedDisplayTeachers(cellData);
        case Constants.RULES_SHOW_RADIO_ASSIGNED_ROOMS:
            return new RulesDisplay.SubjectsAssignedDisplayRooms(cellData);

        default:
            return new RulesDisplay.BlankDisplay(cellData);
    }
}

const getTableCellForElecvtive = (cellData, radioOption) => {

    switch (radioOption) {
        case Constants.RULES_SHOW_RADIO_PERIOD:
            return new RulesDisplay.SubjectsRulesDisplayPeriod(cellData);

        case Constants.RULES_SHOW_RADIO_PERIOD_PREFS:
            return new RulesDisplay.SubjectsRulesDisplayPeriodPref(cellData);


        default:
            return new RulesDisplay.BlankDisplay(cellData);
    }


}

export const getTableCellShowModeForElective = (cellData, radioOption, electiveSubject) => {

    switch (radioOption) {
        case Constants.RULES_SHOW_RADIO_TEACHERS:
            return new RulesDisplay.ElectiveSubjectRulesDisplayForTeachers(cellData, electiveSubject).render();
        case Constants.RULES_SHOW_RADIO_ROOMS:
            return new RulesDisplay.ElectiveSubjectRulesDisplayForRooms(cellData, electiveSubject).render();

        case Constants.RULES_SHOW_RADIO_ASSIGNED_TEACHERS:
            return new RulesDisplay.ElectiveAssignedDisplayForTeachers(cellData, electiveSubject).render();
        case Constants.RULES_SHOW_RADIO_ASSIGNED_ROOMS:
            return new RulesDisplay.ElectiveAssignedDisplayForRooms(cellData, electiveSubject).render();
        default:

    }
}
export const getTableCellShowMode = (cellData, radioOption) => {
    if (cellData && cellData.subject) {
        return getTableCellForSubjects(cellData, radioOption).renderGrid();
    } else {
        return getTableCellForElecvtive(cellData, radioOption).renderGrid();
    }

}

const getDetailsDialogContentSubject = (cellData, props) => {
    let dtailsArray = []
    addMultiPeriodRules(cellData, dtailsArray);
    addJointClassRulesDetails(cellData, dtailsArray, props);
    addPrefferedPeriodDetails(cellData, dtailsArray);

    let fixedTeachersNTA = cellData.fixedTeachersAndTAsForSubject;
    addFixedTeachersAndTAsDetails(fixedTeachersNTA, dtailsArray);

    addPrefeeredRoomDetailsSubject(cellData, dtailsArray);

    let numTeachersnTas = cellData.numberOfTeachersAndTAsForSubject;
    addNumTeachersAndTAs(numTeachersnTas, dtailsArray);
    return dtailsArray;
}

const getDetailsDialogContentElective = (cellData, props) => {
    let dtailsArray = [];
    addMultiPeriodRules(cellData, dtailsArray);
    addJointClassRulesDetails(cellData, dtailsArray, props);
    addPrefferedPeriodDetails(cellData, dtailsArray);
    let fixedTeachersNTA = cellData.fixedTeachersAndTAsForElective;
    addFixedTeachersAndTAsDetailsElective(fixedTeachersNTA, dtailsArray);
    addPrefeeredRoomDetailsElective(cellData, dtailsArray);
    let numTeachersnTas = cellData.numberOfTeachersAndTAsForElective;
    addNumTeachersAndTAs(numTeachersnTas, dtailsArray);

    return dtailsArray;
}

const dayOfWeekAsString = (dayIndex) => {
    return ["Sun", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat"][dayIndex - 1];
}

const addMultiPeriodRules = (cellData, dtailsArray) => {
    if (cellData.multiPeriod && cellData.multiPeriod.preferences && cellData.multiPeriod.preferences.length > 0) {

        cellData.multiPeriod.preferences.forEach(pref => {
            let displayText = 'Multi-Periods: ' + pref.noOfStandardPeriods + ' standard period ' + pref.numberOfInstances + ' times a week'

            addDisplayText(dtailsArray, displayText);
        });

    }
}

const addJointClassRulesDetails = (cellData, dtailsArray, props) => {

    let jointClass = cellData.jointClass;
    if (jointClass) {
        let displayText = 'Joint Class with ' + gradePickerUtil.displayingGradeDetailString_Rules(jointClass.gradeDetails, props);
        addDisplayText(dtailsArray, displayText);
    }
}

const addDisplayText = (dtailsArray, displayText) => {
    dtailsArray.push(<MuiListItem style={{ paddingTop: '0', paddingBottom: '0' }}><MuiListItemText primary={<MuiTypography style={{ fontSize: '12px' }}>{displayText}</MuiTypography>} /></MuiListItem>);

}
const addPrefferedPeriodDetails = (cellData, dtailsArray) => {

    let preferredPeriod = cellData.preferredPeriod;
    if (preferredPeriod && preferredPeriod.preferences && preferredPeriod.preferences.length > 0) {
        let displayText = 'Preferred Period: ';
        for (let x = 0; x < preferredPeriod.preferences.length; x++) {
            let pref = preferredPeriod.preferences[x];
            let periodName = '';
            if (pref.after && pref.after.length > 0) {
                if (pref.before && pref.before.length > 0) {
                    periodName = 'After ' + pref.after + ' and Before ' + pref.before;
                } else {
                    periodName = 'After ' + pref.after;
                }
            } else if (pref.before && pref.before.length > 0) {
                periodName = 'Before ' + pref.before;
            }

            if (x == 0) {
                displayText = displayText + dayOfWeekAsString(pref.weekDay) + ' ' + periodName
            } else {
                displayText = displayText + ' , ' + dayOfWeekAsString(pref.weekDay) + ' ' + periodName
            }

        }
        addDisplayText(dtailsArray, displayText);

    }
}

const addPrefeeredRoomDetailsElective = (cellData, dtailsArray) => {
    let prefRooms = cellData.sharedRoomsForElective;
    if (prefRooms && prefRooms.subjects && prefRooms.subjects.length > 0) {
        let displayText = 'Shared Room For : ';
        prefRooms.subjects.forEach(aSubject => {

            if (aSubject.rooms && aSubject.rooms.length > 0) {
                displayText = displayText + aSubject.subjectName + ' is ' + aSubject.showSharedRoomsForSubjectString + ';';

            }
        });
        //check for hanging comma
        if (displayText != 'Shared Room For : ') {

            addDisplayText(dtailsArray, displayText);

        }
    }

}

const addPrefeeredRoomDetailsSubject = (cellData, dtailsArray) => {
    let prefRooms = cellData.sharedRoomsForSubject;
    //sharedRoomsForSubject
    if (prefRooms && prefRooms.room && prefRooms.room.length) {
        let displayText = 'Preferred Room: ';

        for (let x = 0; x < prefRooms.room.length; x++) {
            let aroom = prefRooms.room[x];
            if (x === 0) {
                displayText = displayText + aroom.name;
            } else {
                displayText = displayText + ' , ' + aroom.name;
            }
        }
        addDisplayText(dtailsArray, displayText);
    }
}

const addFixedTeachersAndTAsDetails = (fixedTeachersNTA, dtailsArray) => {
    if (fixedTeachersNTA) {
        let displayText = '';
        if (fixedTeachersNTA.teachers && fixedTeachersNTA.teachers.fixed && fixedTeachersNTA.teachers.fixed.length > 0) {
            displayText = 'Fixed Teachers: ';
            for (let x = 0; x < fixedTeachersNTA.teachers.fixed.length; x++) {
                let fixedTeachers = fixedTeachersNTA.teachers.fixed[x];
                if (x == 0) {
                    displayText = displayText + fixedTeachers.teacherId;
                } else {
                    displayText = displayText + ', ' + fixedTeachers.teacherId;
                }
            }
        }
        if (fixedTeachersNTA.teachers && fixedTeachersNTA.teachers.preferred && fixedTeachersNTA.teachers.preferred.length > 0) {
            displayText = displayText.length > 0 ? displayText + ' & Preferred Teachers: ' : 'Preferred Teachers: ';
            for (let x = 0; x < fixedTeachersNTA.teachers.preferred.length; x++) {
                let preTeachers = fixedTeachersNTA.teachers.preferred[x];
                if (x == 0) {
                    displayText = displayText + preTeachers.teacherId;
                } else {
                    displayText = displayText + ', ' + preTeachers.teacherId;
                }
            }
        }

        if (displayText.length > 0) {
            addDisplayText(dtailsArray, displayText);
        }
 //TA's
        displayText = '';
        if (fixedTeachersNTA.TAs && fixedTeachersNTA.TAs.fixed && fixedTeachersNTA.TAs.fixed.length > 0) {
            displayText = 'Fixed TAs: ';
            for (let x = 0; x < fixedTeachersNTA.TAs.fixed.length; x++) {
                let fixedTAs = fixedTeachersNTA.TAs.fixed[x];
                if (x === 0) {
                    displayText = displayText + fixedTAs.teacherId;
                } else {
                    displayText = displayText + ', ' + fixedTAs.teacherId;
                }
            }
        }
        if (fixedTeachersNTA.TAs && fixedTeachersNTA.TAs.preferred && fixedTeachersNTA.TAs.preferred.length > 0) {
            displayText = displayText.length > 0 ? displayText + ' & Preferred TAs: ' : 'Preferred TAs: ';
            for (let x = 0; x < fixedTeachersNTA.TAs.preferred.length; x++) {
                let preTAs = fixedTeachersNTA.TAs.preferred[x];
                if (x == 0) {
                    displayText = displayText + preTAs.teacherId;
                } else {
                    displayText = displayText + ', ' + preTAs.teacherId;
                }
            }
        }

        if (displayText.length > 0) {
            addDisplayText(dtailsArray, displayText);
        }
    }
}

const addFixedTeachersAndTAsDetailsElective = (fixedTeachersNTA, dtailsArray) => {
    if (fixedTeachersNTA && fixedTeachersNTA.teachersAndTAs && fixedTeachersNTA.teachersAndTAs.length > 0) {
        let displayText = '';
        fixedTeachersNTA.teachersAndTAs.forEach(ateacherNTA => {
            if (ateacherNTA.teachers && ateacherNTA.teachers.fixed && ateacherNTA.teachers.fixed.length > 0) {
                displayText = 'Fixed Teachers: ';
                for (let x = 0; x < ateacherNTA.teachers.fixed.length; x++) {
                    let fixedTeachers = ateacherNTA.teachers.fixed[x];
                    if (x == 0) {
                        displayText = displayText + fixedTeachers.teacherId;
                    } else {
                        displayText = displayText + ', ' + fixedTeachers.teacherId;
                    }
                }
            }
            if (ateacherNTA.teachers && ateacherNTA.teachers.preferred && ateacherNTA.teachers.preferred.length > 0) {
                displayText = displayText.length > 0 ? displayText + ' & Preferred Teachers: ' : 'Preferred Teachers: ';
                for (let x = 0; x < ateacherNTA.teachers.preferred.length; x++) {
                    let preTeachers = ateacherNTA.teachers.preferred[x];
                    if (x == 0) {
                        displayText = displayText + preTeachers.teacherId;
                    } else {
                        displayText = displayText + ', ' + preTeachers.teacherId;
                    }
                }
            }
        });


        if (displayText.length > 0) {
            addDisplayText(dtailsArray, displayText);
        }
    }
}

const addNumTeachersAndTAs = (numTeachersnTas, dtailsArray) => {
    if (numTeachersnTas) {
        //teachers,TAs
        let displayText = '';
        if (numTeachersnTas.teachers > 0 && numTeachersnTas.TAs > 0) {
            displayText = 'Number of Teachers: ' + numTeachersnTas.teachers + ' & Number of TAs: ' + numTeachersnTas.TAs;
        } else if (numTeachersnTas.teachers > 0) {
            displayText = 'Number of Teachers: ' + numTeachersnTas.teachers;
        } else if (numTeachersnTas.TAs > 0) {
            displayText = 'Number of TAs: ' + numTeachersnTas.TAs;
        }
        addDisplayText(dtailsArray, displayText);
    }
}
export const getTextForRulesDisplayTab = (cellData, props) => {

    if (cellData.subject) {
        return getDetailsDialogContentSubject(cellData, props);
    } else if (cellData.elective) {
        return getDetailsDialogContentElective(cellData, props);
    }
}

const toasterForShowRadioClick = (msg1, msg2, msg3) => {
    if (toast.isActive("rules_show_radio")) {

        toast.dismiss("rules_show_radio");

    }
    if (msg3) {
        toast.info((() => <div>{msg1} <br />{msg2} <br />{msg3}</div>), { position: toast.POSITION.TOP_CENTER, toastId: 'rules_show_radio', className: 'rules_toaster', closeButton: true, timeOut: 4000, progressBar: true });

    } else {
        toast.info((() => <div>{msg1} <br />{msg2}</div>), { position: toast.POSITION.TOP_CENTER, toastId: 'rules_show_radio', className: 'rules_toaster', closeButton: true, timeOut: 4000, progressBar: true });

    }

}

export const showToasterForRulesDisplay = (radiovalue, i18n) => {
    switch (radiovalue) {
        case Constants.RULES_SHOW_RADIO_PERIOD:
            toasterForShowRadioClick(i18n.rules.showPeriodRulesToastMessageLine1,
                i18n.rules.showPeriodRulesToastMessageLine2);
            break;
        case Constants.RULES_SHOW_RADIO_PERIOD_PREFS:
            toasterForShowRadioClick(i18n.rules.showPeriodPrefRulesToastMessageLine1,
                i18n.rules.showPeriodPrefRulesToastMessageLine2);
            break;
        case Constants.RULES_SHOW_RADIO_ROOMS:
            toasterForShowRadioClick(i18n.rules.showRoomRulesToastMessageLine1,
                i18n.rules.showRoomRulesToastMessageLine2);
            break;
        case Constants.RULES_SHOW_RADIO_TEACHERS:
            toasterForShowRadioClick(i18n.rules.showTeacherRulesToastMessageLine1,
                i18n.rules.showTeacherRulesToastMessageLine2,
                i18n.rules.showTeacherRulesToastMessageLine3);
            break;
        case Constants.RULES_SHOW_RADIO_ASSIGNED_ROOMS:
            toasterForShowRadioClick(i18n.rules.showAssignedRoomsToastMessageLine1,
                i18n.rules.showAssignedRoomsToastMessageLine2);
            break;
        case Constants.RULES_SHOW_RADIO_ASSIGNED_TEACHERS:
            toasterForShowRadioClick(i18n.rules.showAssignedTeachersToastMessageLine1,
                i18n.rules.showAssignedTeachersToastMessageLine2,
                i18n.rules.showAssignedTeachersToastMessageLine3);
            break;
        default:
            toasterForShowRadioClick(i18n.rules.showPeriodRulesToastMessageLine1,
                i18n.rules.showPeriodRulesToastMessageLine2);
    }
}



